import React, { useMemo, useState } from 'react';

const executives = [
  {
    name: 'Surv. Yakubu Najimu Atanda FNIS',
    designation: 'Chairman',
    photo: 'Chariman.jpeg',
    highlight: true,
  },
  {
    name: 'Surv. Abayomi K. Otitoju MNIS',
    designation: 'Vice Chairman',
    photo: 'Abayomi Otituju.jpeg',
  },
  {
    name: 'Surv. Yusuf Obaje Yunusa MNIS',
    designation: 'Secretary',
    photo: "vsecretary's picture.jpeg",
  },
  {
    name: 'Surv. Ayuba Adamu Samuel MNIS',
    designation: 'Assistant Secretary',
    photo: 'Ayuba Samuel Adamu.jpeg',
  },
  {
    name: 'Surv. Ekele John Ifene MNIS',
    designation: 'Treasurer',
    photo: 'Ekele John Ifene.jpeg',
  },
  {
    name: 'Surv. Omorogie Joseph Onyewelu MNIS',
    designation: 'Financial Secretary',
    photo: 'Omorogie Joseph Onyewelu.jpeg',
  },
  {
    name: 'Surv. Dr Izuegbu Ogochukwu Uju MNIS',
    designation: 'Council Representative',
    photo: 'IZUEGBU, Ogochukwu Uju.jpeg',
  },
  {
    name: 'Surv. Fashikun ADENIYI MNIS',
    designation: 'Internal Auditor',
    photo: 'Fashikun Adeniyi Samuel.jpeg',
  },
  {
    name: 'Surv. Gbenga Samuel Oyeyinka MNIS',
    designation: 'Publicity Secretary',
    photo: 'Oyeyinka Samuel Gbenga.jpeg',
  },
  {
    name: 'Surv. Mrs. Okeke Vyvian Amara MNIS',
    designation: 'Welfare Officer',
    photo: 'Vyvian Amara Okeke.jpeg',
  },
  {
    name: 'Surv. A. A. Alonge FNIS',
    designation: 'Ex Officio 1',
    photo: 'A. A. Alonge.jpeg',
  },
  {
    name: 'Surv. Alfred Adeojo MNIS',
    designation: 'Ex Officio 2',
    photo: 'Alfred Adeojo.jpeg',
  },
];

const imagePath = (filename) => encodeURI(`/${filename}`);

function ExecutiveCard({ executive, index = 0 }) {
  return (
    <article
      className="group relative overflow-hidden rounded-2xl border border-[#0B5D1E]/10 bg-white shadow-[0_12px_30px_rgba(11,93,30,0.08)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(11,93,30,0.18)] executive-card-enter"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#eef5f0]">
        <img
          src={imagePath(executive.photo)}
          alt={`${executive.name} - ${executive.designation}`}
          className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-black/45 via-black/20 to-transparent" />
      </div>

      <div className="p-5">
        <h3 className="text-[1.04rem] font-bold leading-snug text-[#0B5D1E]" style={{ fontFamily: "'Playfair Display', serif" }}>
          {executive.name}
        </h3>
        <p className="mt-2 inline-flex items-center rounded-full bg-[#C8A951]/15 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-[#7a651f]">
          {executive.designation}
        </p>
      </div>
    </article>
  );
}

export default function ExecutiveMembers() {
  const [searchTerm, setSearchTerm] = useState('');
  const [designationFilter, setDesignationFilter] = useState('all');

  const designationOptions = useMemo(() => {
    return ['all', ...new Set(executives.map((m) => m.designation))];
  }, []);

  const filteredExecutives = useMemo(() => {
    const needle = searchTerm.trim().toLowerCase();
    return executives.filter((m) => {
      const byDesignation = designationFilter === 'all' || m.designation === designationFilter;
      const bySearch = !needle || `${m.name} ${m.designation}`.toLowerCase().includes(needle);
      return byDesignation && bySearch;
    });
  }, [designationFilter, searchTerm]);

  const chairman = filteredExecutives.find((m) => m.highlight);
  const others = filteredExecutives.filter((m) => !m.highlight);

  return (
    <div className="bg-[#f4f8f5]">
      <style>{`
        @keyframes executiveCardEnter {
          from {
            opacity: 0;
            transform: translateY(14px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .executive-card-enter {
          opacity: 0;
          animation: executiveCardEnter 560ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
        }
      `}</style>
      <section className="relative isolate overflow-hidden bg-[#0B5D1E]">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(200,169,81,0.28),transparent_45%),radial-gradient(circle_at_80%_0%,rgba(255,255,255,0.12),transparent_35%)]" />
        <div className="relative mx-auto max-w-7xl px-4 pb-16 pt-16 sm:px-6 lg:px-8 lg:pb-20 lg:pt-20">
          <div className="mx-auto max-w-3xl text-center">
            <p className="inline-flex rounded-full border border-white/30 px-4 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-white/90">
              NIS FCT Branch
            </p>
            <h1 className="mt-5 text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl" style={{ fontFamily: "'Playfair Display', serif" }}>
              NIS FCT Executives
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-white/80 sm:text-lg">
              Meet the elected leadership team serving the Nigerian Institution of Surveyors, FCT Branch.
            </p>
          </div>
        </div>
      </section>

      {chairman && (
        <section className="mx-auto max-w-7xl px-4 pb-8 pt-10 sm:px-6 lg:px-8 lg:pt-14">
          <div className="mx-auto flex max-w-3xl flex-col items-center overflow-hidden rounded-3xl border border-[#0B5D1E]/10 bg-white shadow-[0_20px_50px_rgba(11,93,30,0.12)] md:max-w-4xl md:flex-row">
            <div className="relative w-full flex-shrink-0 overflow-hidden md:w-[300px] lg:w-[340px]">
              <div className="aspect-[3/4] w-full">
              <img
                src={imagePath(chairman.photo)}
                alt={`${chairman.name} - ${chairman.designation}`}
                className="h-full w-full object-cover"
              /></div>
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black/25 via-transparent to-transparent" />
            </div>
            <div className="flex flex-1 flex-col justify-center p-6 sm:p-8 lg:p-10">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#0B5D1E]/75">Principal Officer</p>
              <h2 className="mt-3 text-3xl font-bold text-[#0B5D1E]" style={{ fontFamily: "'Playfair Display', serif" }}>
                {chairman.name}
              </h2>
              <p className="mt-3 text-lg font-semibold text-[#7a651f]">{chairman.designation}</p>
              <div className="mt-6 h-px w-24 bg-[#C8A951]" />
              <p className="mt-6 text-sm leading-relaxed text-gray-600">
                Provides strategic direction for the branch and leads the executive council in advancing professional surveying practice, member welfare, and institutional growth in the FCT.
              </p>
            </div>
          </div>
        </section>
      )}

      <section className="mx-auto max-w-7xl px-4 pb-16 pt-6 sm:px-6 lg:px-8 lg:pb-20">
        <div className="mb-8 flex items-end justify-between gap-4">
          <div>
            <h2 className="text-2xl font-bold text-[#0B5D1E] sm:text-3xl" style={{ fontFamily: "'Playfair Display', serif" }}>
              Executive Council Members
            </h2>
            <p className="mt-2 text-sm text-gray-600 sm:text-base">
              Officers and representatives working together to drive administration, finance, governance, and member engagement.
            </p>
          </div>
          <span className="hidden rounded-full bg-[#0B5D1E]/8 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-[#0B5D1E] sm:inline-flex">
            {filteredExecutives.length} Members
          </span>
        </div>

        <div className="mb-8 grid grid-cols-1 gap-3 rounded-2xl border border-[#0B5D1E]/10 bg-white p-4 shadow-[0_10px_24px_rgba(11,93,30,0.08)] md:grid-cols-[1fr_auto] md:items-center">
          <label className="block">
            <span className="mb-1 block text-xs font-semibold uppercase tracking-wider text-[#0B5D1E]/70">Search Executive</span>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search by name or designation"
              className="w-full rounded-xl border border-[#0B5D1E]/20 bg-[#f8fbf9] px-4 py-2.5 text-sm text-gray-800 outline-none transition focus:border-[#0B5D1E]/50 focus:bg-white focus:ring-2 focus:ring-[#0B5D1E]/15"
            />
          </label>

          <label className="block md:min-w-[240px]">
            <span className="mb-1 block text-xs font-semibold uppercase tracking-wider text-[#0B5D1E]/70">Filter Designation</span>
            <select
              value={designationFilter}
              onChange={(e) => setDesignationFilter(e.target.value)}
              className="w-full rounded-xl border border-[#0B5D1E]/20 bg-[#f8fbf9] px-4 py-2.5 text-sm text-gray-800 outline-none transition focus:border-[#0B5D1E]/50 focus:bg-white focus:ring-2 focus:ring-[#0B5D1E]/15"
            >
              {designationOptions.map((designation) => (
                <option key={designation} value={designation}>
                  {designation === 'all' ? 'All Designations' : designation}
                </option>
              ))}
            </select>
          </label>
        </div>

        {others.length > 0 && (() => {
          const cols = 4;
          const remainder = others.length % cols;
          const fullRowCount = others.length - remainder;
          const mainCards = others.slice(0, fullRowCount);
          const lastRowCards = others.slice(fullRowCount);
          return (
            <>
              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {mainCards.map((executive, index) => (
                  <ExecutiveCard key={`${executive.name}-${executive.designation}`} executive={executive} index={index} />
                ))}
              </div>
              {lastRowCards.length > 0 && (
                <div className="mt-5 flex flex-wrap justify-center gap-5">
                  {lastRowCards.map((executive, index) => (
                    <div key={`${executive.name}-${executive.designation}`} className="w-full sm:w-[calc(50%-10px)] lg:w-[calc(25%-15px)] xl:w-[calc(25%-15px)]" style={{ maxWidth: '280px' }}>
                      <ExecutiveCard executive={executive} index={fullRowCount + index} />
                    </div>
                  ))}
                </div>
              )}
            </>
          );
        })()}

        {filteredExecutives.length === 0 && (
          <div className="rounded-2xl border border-dashed border-[#0B5D1E]/25 bg-white px-5 py-10 text-center text-sm text-gray-600">
            No executive matches your current search or filter.
          </div>
        )}
      </section>
    </div>
  );
}
